{
  "Account": "Nalog",
  "AfternoonSlot": "Poslepodne",
  "AllCategories": "Sve",
  "AlreadyHaveAccount": "Već imate nalog?",
  "Announcements": "Objave",
  "AnyTimeSlot": "Svejedno",
  "Apply": "Primeni",
  "AllSlotsBooked": "Svi termini su zauzeti",
  "AreYouSure": "Da li ste sigurni?",
  "Back": "Nazad",
  "BackStep": "Nazad",
  "BasedOnReviews": "Na osnovu {0} recenzija",
  "BecomePartner": "Postani partner",
  "Birthday": "Rođendan",
  "Book": "Zakaži",
  "BookingConfirmedDescription": "Vidimo se u zakazanom terminu!",
  "BookingConfirmedSuccess": "Termin je uspešno zakazan!",
  "BookingStepOf": "Korak {{current}} od {{total}}",
  "BlogSubtitle": "Saveti, trendovi i korisne informacije iz sveta lepote i zdravlja",
  "BlogTitle": "Blog",
  "BenefitEasyDesc": "Jednostavan interfejs koji svako može koristiti",
  "BenefitEasyTitle": "Lako za korišćenje",
  "BenefitFastDesc": "Zakažite termin za manje od minut",
  "BenefitFastTitle": "Brzo zakazivanje",
  "BenefitFreeDesc": "Korišćenje platforme je potpuno besplatno",
  "BenefitFreeTitle": "Besplatno",
  "BenefitRemindersDesc": "Dobijate podsetnik pre zakazanog termina",
  "BenefitRemindersTitle": "Podsetnici",
  "BookAppointment": "Zakaži termin",
  "CategoriesPageSubtitle": "Izaberite uslugu i zakažite termin online",
  "CityPageSubtitle": "Zakažite termin online u gradu {{city}}",
  "BusinessNameLabel": "Naziv biznisa",
  "BusinessNamePlaceholder": "Unesite naziv biznisa",
  "ByRegisteringAccept": "Registracijom prihvatam",
  "BySubmittingAccept": "Slanjem zahteva prihvatam",
  "CancelBooking": "Otkaži",
  "ChangePasswordTitle": "Lozinka",
  "CloseButton": "Zatvori",
  "CommentEncouragement": "Vaši komentari mnogo znače!",
  "CommentPlaceholder": "Unesite komentar",
  "CompleteRegistration": "Dopuni registraciju",
  "CompleteRegistrationButton": "Završi registraciju",
  "CompleteRegistrationDescription": "Dobrodošli! Unesite broj telefona da biste završili registraciju za",
  "ConfirmBooking": "Potvrdi",
  "Continue": "Nastavi",
  "MoreDetails": "Detalji",
  "ConfirmNewPasswordLabel": "Potvrda nove lozinke",
  "ConfirmPasswordLabel": "Potvrda lozinke",
  "ConfirmPasswordPlaceholder": "Potvrdite lozinku",
  "ConfirmYouAreHuman": "Molimo vas da potvrdite da ste čovek.",
  "Coupon": "Kupon",
  "CurrentPasswordLabel": "Trenutna lozinka",
  "CustomerReviews": "Recenzije",
  "DateLabel": "Datum",
  "Day": "Dan",
  "Discount": "Popust",
  "EmailAddressLabel": "Email adresa",
  "EmailLabel": "Email",
  "EmailPlaceholder": "Unesite email",
  "EnterCouponCode": "Unesite kod kupona",
  "EnterEmail": "Unesite email",
  "EnterEmailAddress": "Unesite email adresu",
  "EnterPassword": "Unesite lozinku",
  "EnterPhoneNumber": "Unesite broj telefona",
  "EnterTelephone": "Unesite telefon",
  "EnterValidEmailAddress": "Unesite validnu email adresu",
  "ErrorBoundaryDescription": "Došlo je do neočekivane greške. Molimo pokušajte ponovo.",
  "FavoriteTenants": "Omiljeni",
  "FaqAccountAnswer": "Nije obavezan, ali sa nalogom dobijate praćenje termina, podsetnike i druge pogodnosti. Registracija je brza i besplatna.",
  "FaqAccountQuestion": "Da li mi treba nalog?",
  "FaqCancelAnswer": "Da, termin možete otkazati u svakom trenutku iz sekcije Moje rezervacije.",
  "FaqCancelQuestion": "Mogu li da otkažem termin?",
  "FaqCitiesAnswer": "Trenutno smo dostupni u više gradova u Srbiji i stalno se širimo. Proverite listu gradova na početnoj stranici.",
  "FaqCitiesQuestion": "U kojim gradovima je dostupna usluga?",
  "FaqFreeAnswer": "Da, korišćenje platforme je potpuno besplatno za klijente. Ne postoje skriveni troškovi.",
  "FaqFreeQuestion": "Da li je zakazivanje besplatno?",
  "FaqTitle": "Česta pitanja",
  "FindPerfect": "Pronađite savršenu",
  "ForgotPasswordLink": "Zaboravljena lozinka?",
  "ForgotPasswordTitle": "Zaboravili ste lozinku?",
  "FullNameLabel": "Ime i Prezime",
  "FullNamePlaceholder": "Ime i prezime",
  "GoToHomePage": "Idi na početnu stranicu",
  "HairLengthLabel": "Dužina",
  "Home": "Početna",
  "HowItWorksCtaButton": "Pregledaj usluge",
  "HowItWorksCtaTitle": "Spremni za zakazivanje?",
  "HowItWorksSubtitle": "Zakažite termin u samo par klikova – brzo, lako i potpuno besplatno.",
  "HowItWorksTitle": "Kako funkcioniše?",
  "Info": "Info",
  "InvalidEmail": "Unesite validnu email adresu",
  "InvalidPhoneNumberFormat": "InvalidPhoneNumberFormat",
  "LearnMore": "Saznaj više o platformi",
  "LoadMore": "Učitaj još",
  "LoadingTip": "Učitavanje...",
  "LoginBrandSubtitle": "Zakažite termin brzo i jednostavno, bilo kada i bilo gde.",
  "LoginSubtitle": "Prijavite se na svoj nalog",
  "LogInButton": "Prijavi Me",
  "LogInHeader": "Prijavi Me",
  "LogOutMenu": "Odjavi Me",
  "MenuTitle": "Meni",
  "MessageLabel": "Poruka",
  "MessagePlaceholder": "Unesite poruku (opciono)",
  "Month": "Mesec",
  "MoreAboutUs": "Više o nama",
  "MorningSlot": "Prepodne",
  "MyBookingsMenu": "Rezervacije",
  "MyBookingsTitle": "Moje rezervacije",
  "MyProfile": "Profil",
  "UpcomingBooking": "Predstojeća rezervacija",
  "NoUpcomingBookings": "Nemate predstojeće rezervacije",
  "NoUpcomingBookingsHint": "Zakažite termin u par koraka",
  "FindSalon": "Pronađi salon",
  "Today": "Danas",
  "Tomorrow": "Sutra",
  "Shortcuts": "Prečice",
  "QuickActions": "Brze akcije",
  "FavoritesTitle": "Omiljeni saloni",
  "FavoritesSubtitle": "Brzo zakažite termin u salonima koje volite",
  "NoFavoritesYet": "Još nemate omiljene salone",
  "NoFavoritesHint": "Označite srce na salonu da biste ga dodali ovde",
  "RemoveFromFavorites": "Ukloni iz omiljenih",
  "Settings": "Podešavanja",
  "Language": "Jezik",
  "Support": "Podrška",
  "HelpMenu": "Pomoć",
  "ContactMenu": "Kontakt",
  "MaxBookingHint": "Datum je van dozvoljenog perioda za rezervacije",
  "NameLabel": "Ime",
  "NamePlaceholder": "Unesite ime",
  "NewAppointment": "Novi termin?",
  "NewPasswordLabel": "Nova lozinka",
  "Next": "Sledeće",
  "NextStep": "Dalje",
  "No": "Ne",
  "NoAnnouncements": "Nema objava",
  "NoAnswer": "Ne",
  "NoBookings": "Nemate rezervacija",
  "NoBlogPosts": "Nema objavljenih članaka",
  "NoData": "Nema podataka",
  "NoReviews": "Nema komentara",
  "NoSlotsAvailablePrefix": "Na žalost",
  "NoSlotsAvailableSuffix": "nema slobodnih termina za",
  "NotSure": "Niste sigurni?",
  "NoteLabel": "Napomena",
  "NotePlaceholder": "Unesite napomenu",
  "NonWorkingDayHint": "Neradan dan",
  "OrAnotherWorker": "ili drugog radnika",
  "OrLabel": "ili",
  "SocialLoginInAppHint": "Prijava preko Google ili Facebook naloga radi samo u Safari ili Chrome pregledaču. Otvorite stranicu tamo (··· → Open in external browser) ili se prijavite emailom.",
  "PageNotFoundDescription": "Stranica koju tražite ne postoji.",
  "PageNotFoundTitle": "404 - Stranica nije pronađena",
  "PastDateHint": "Datum je prošao",
  "PartnerBenefit1": "Online zakazivanje",
  "PartnerBenefit2": "Pregledan kalendar",
  "PartnerBenefit3": "Upravljanje timom",
  "PartnerBenefit4": "Kontrola usluga",
  "PartnerBenefit5": "Promocije i objave",
  "PartnerBenefit6": "Mobilna aplikacija",
  "PartnerHeroSubtitle": "Pridružite se platformi Rasporedi Me i omogućite klijentima da zakažu termin online. Upravljajte terminima uz pregledan kalendar, kontrolišite usluge, kreirajte promocije i objave — sve na jednom mestu.",
  "PriceListNotAvailable": "Cenovnik trenutno nije dostupan.",
  "PriceListTitle": "Cenovnik usluga",
  "PartnerHeroTitle": "Postanite naš partner",
  "PartnerInquirySuccessSubtitle": "Hvala vam na interesovanju. Kontaktiraćemo vas u najkraćem roku.",
  "PartnerInquirySuccessTitle": "Prijava je uspešno poslata!",
  "PasswordChangeError": "Došlo je do greške prilikom promene lozinke.",
  "PasswordLabel": "Lozinka",
  "PasswordResetCodeSent": "Uputstvo za resetovanje lozinke je poslato na vašu email adresu.",
  "PasswordSuccessfullyChanged": "Lozinka uspešno promenjena.",
  "PhoneLabel": "Broj telefona",
  "PhoneNumberInvalid": "Unesite ispravan broj telefona",
  "PhoneNumberLabel": "Broj telefona",
  "PhoneNumberRequired": "Broj telefona je obavezan",
  "PhonePlaceholder": "Broj telefona",
  "PleaseSelectAnotherDate": "molimo vas izaberite drugi datum",
  "Promotion": "Promocija",
  "Promotions": "Promocije",
  "ProveYouAreHuman": "Dokažite da ste čovek",
  "PwaGuideAndroidStep1": "Otvori Rasporedi Me u pregledaču <b>Chrome</b>.",
  "PwaGuideAndroidStep2": "Dodirni meni <b>⋮</b> (tri tačke) u gornjem desnom uglu.",
  "PwaGuideAndroidStep3": "Izaberi <b>„Instaliraj aplikaciju“</b> ili <b>„Dodaj na početni ekran“</b>, pa potvrdi sa <b>„Instaliraj“</b>.",
  "PwaGuideAndroidStep4": "Ikonica Rasporedi Me se pojavljuje na početnom ekranu i u listi aplikacija — otvaraj aplikaciju odatle.",
  "PwaGuideAndroidTip": "<b>Samsung Internet:</b> meni <b>☰</b> → „Dodaj stranicu u“ → „Početni ekran“. Ako ne vidiš opciju za instalaciju, ažuriraj Chrome na najnoviju verziju.",
  "PwaGuideButton": "Uputstvo",
  "PwaGuideClose": "Zatvori",
  "PwaGuideDesktopStep1": "Otvori Rasporedi Me u pregledaču <b>Chrome</b> ili <b>Edge</b>.",
  "PwaGuideDesktopStep2": "Klikni na ikonicu za instalaciju (monitor sa strelicom nadole) na desnom kraju adresne trake.",
  "PwaGuideDesktopStep3": "Ako je ne vidiš: <b>Chrome</b> meni ⋮ → „Prebaci, sačuvaj i deli“ → <b>„Instaliraj stranicu kao aplikaciju“</b>; <b>Edge</b> meni ⋯ → „Aplikacije“ → <b>„Instaliraj ovaj sajt kao aplikaciju“</b>.",
  "PwaGuideDesktopStep4": "Potvrdi sa <b>„Instaliraj“</b>. Aplikacija se otvara u svom prozoru i možeš je zakačiti na traku zadataka ili Dock.",
  "PwaGuideDesktopTip": "<b>Safari na Mac-u:</b> meni „File“ → <b>„Add to Dock“</b>. Firefox ne podržava instalaciju aplikacija — koristi Chrome ili Edge.",
  "PwaGuideInstallNow": "Instaliraj odmah",
  "PwaGuideIntro": "Rasporedi Me možeš instalirati kao aplikaciju za par sekundi — bez prodavnice aplikacija. Prikazujemo uputstvo za tvoj uređaj, a možeš izabrati i drugi.",
  "PwaGuideIosStep1": "Otvori Rasporedi Me u pregledaču <b>Safari</b>.",
  "PwaGuideIosStep2": "Dodirni dugme za deljenje (kvadrat sa strelicom nagore) — na dnu ekrana na iPhone-u, gore desno na iPad-u. Na novijim iOS verzijama prvo dodirni <b>•••</b>, pa <b>„Deli“</b>.",
  "PwaGuideIosStep3": "Skroluj nadole i izaberi <b>„Dodaj na početni ekran“</b>.",
  "PwaGuideIosStep4": "Ostavi uključeno <b>„Otvori kao veb aplikaciju“</b> i dodirni <b>„Dodaj“</b> u gornjem desnom uglu.",
  "PwaGuideIosStep5": "Ikonica Rasporedi Me se pojavljuje na početnom ekranu — otvaraj aplikaciju odatle.",
  "PwaGuideIosTip": "Od iOS 16.4 ovo radi i iz Chrome-a i Edge-a (dugme za deljenje u adresnoj traci). U nekim drugim pregledačima opcija ne postoji — tada koristi Safari.",
  "PwaGuideLink": "Kako?",
  "PwaGuidePlatformAndroid": "Android",
  "PwaGuidePlatformDesktop": "Računar",
  "PwaGuidePlatformIos": "iPhone",
  "PwaGuideTitle": "Kako instalirati aplikaciju",
  "PwaInstallAccept": "Instaliraj",
  "PwaInstallDescription": "Brži pristup i nativni osećaj — dodaj Rasporedi Me na početni ekran.",
  "PwaInstallIOSDescription": "Klikni na dugme za deljenje pa izaberi \"Dodaj na početni ekran\".",
  "PwaInstallTitle": "Instaliraj aplikaciju",
  "RateMe": "Oceni me",
  "RateUs": "Ocenite",
  "RegisterMeBtn": "Registruj Me",
  "RegisterMeHeader": "Registruj Me",
  "RegistrationIllustrationText": "Kreirajte nalog i zakažite prvi termin.",
  "RegistrationSubtitle": "Popunite podatke ispod",
  "RegistrationSuccessMessage": "Email sa linkom za potvrdu registracije je poslat. Molimo Vas da proverite svoj email i klikom na dugme za potvrdu aktivirate svoj nalog. Hvala Vam sto koristite naše usluge!",
  "RegistrationTitle": "Registracija",
  "RequestSentDescription": "Očekujte odgovor u roku od 24h.",
  "RequestSentSuccess": "Tvoj zahtev je uspešno stigao.",
  "CanCloseThisPage": "Možeš da zatvoriš ovu stranicu.",
  "RequiredField": "Obavezno polje!",
  "SatisfiedWithService": "Zadovoljni ste uslugom?",
  "SaveButton": "Sačuvaj",
  "ScheduleAppointmentToday": "Zakažite termin već danas",
  "ScheduleInFewClicks": "Zakažite termin u par klikova brzo i lako.",
  "Search": "Pretraga",
  "SearchByName": "Pretraži po imenu",
  "SearchServices": "Pretraži usluge",
  "SearchWorker": "Pretraži radnika",
  "ClearAll": "Obriši sve",
  "NoServicesFound": "Nijedna usluga ne odgovara pretrazi",
  "NoResultsFound": "Nema rezultata",
  "NoCategories": "Trenutno nema dostupnih kategorija",
  "NoServicesInCity": "Trenutno nema dostupnih usluga u ovom gradu",
  "SeeAll": "Pogledaj sve",
  "SeeReviews": "Pogledaj recenzije",
  "SelectRating": "Izaberite ocenu",
  "SelectServices": "Izaberite usluge",
  "SelectTown": "Izaberite grad",
  "SelectWorker": "Izaberite radnika",
  "SendResetLink": "Izmeni lozinku",
  "ServiceCategories": "Kategorije usluga",
  "ServiceForYou": "uslugu za vas",
  "ServicesLabel": "Usluge",
  "SignInWithFacebook": "Пријавите се помоћу Facebook-а",
  "SomethingWentWrong": "Nešto je pošlo naopako",
  "SortBy": "Sortiraj",
  "SortName": "Naziv A–Š",
  "SortNewest": "Najnovije",
  "SortRating": "Najviša ocena",
  "SortRecommended": "Preporučeno",
  "StepBookDesc": "Izaberite datum i vreme koje vam odgovara i potvrdite termin.",
  "StepBookTitle": "Zakažite termin",
  "StepChooseDesc": "Izaberite kategoriju usluge koja vam je potrebna — frizeri, kozmetičari, nokti i još mnogo toga.",
  "StepChooseTitle": "Izaberite uslugu",
  "StepConfirmDesc": "Dobićete potvrdu i podsetnik pre zakazanog termina.",
  "StepConfirmTitle": "Potvrda",
  "StepPickDesc": "Pregledajte profile, ocene i recenzije kako biste pronašli najboljeg pružaoca usluge.",
  "StepPickTitle": "Pronađite salon",
  "StatusCanceled": "Otkazana",
  "StatusConfirmed": "Potvrđena",
  "StatusNoShow": "Nije došao",
  "StatusPending": "Na čekanju",
  "Submit": "Pošalji",
  "SubmitPartnerInquiry": "Pošaljite prijavu",
  "SubmitRequest": "Pošalji zahtev",
  "SubmitRequestError": "Došlo je do greške prilikom slanja zahteva! Molimo pokušajte ponovo.",
  "SuccessfulRegistration": "Uspešna registracija!",
  "SuccessfullyAdded": "Uspešno dodato",
  "SuccessfullyChanged": "Uspešno izmenjeno",
  "SurnameLabel": "Prezime",
  "SurnamePlaceholder": "Unesite prezime",
  "SurveyAnonymousNotice": "Vaši odgovori su potpuno anonimni",
  "TabPast": "Istorija",
  "TabUnassigned": "Zahtevi",
  "TabUpcoming": "Termini",
  "PrivacyPolicy": "Politika privatnosti",
  "TelephoneLabel": "Telefon",
  "TermsAndConditionsTitle": "Uslovi korišćenja",
  "TermsOfService": "uslove korišćenja",
  "ThankYouForFeedback": "Hvala vam na odgovoru!",
  "ThankYouForServices": "Hvala Vam sto koristite naše usluge!",
  "TimeLabel": "Vreme",
  "Town": "Grad",
  "TownLabel": "Grad",
  "Unscheduled": "Neraspoređeno",
  "UnavailabilityHint": "Termin nije dostupan (odsustvo)",
  "VerificationFailed": "Neuspešna verifikacija!",
  "VerificationFailedMessage": "Neuspešna verifikacija! Molimo Vas pokušajte ponovo. Hvala Vam sto koristite naše usluge!",
  "VerificationSuccess": "Uspešna verifikacija!",
  "VerificationSuccessMessage": "Uspešno ste verifikovali nalog. Sada se možete prijaviti. Hvala Vam sto koristite naše usluge!",
  "ViewCategory": "Pogledaj",
  "Welcome": "Dobrodošli",
  "WhyRasporediMe": "Zašto Rasporedi Me?",
  "WorkerLabel": "Radnik",
  "Year": "Godina",
  "Yes": "Da",
  "YesAnswer": "Da",
  "YourAnswer": "Vaš odgovor",
  "PricingTitle": "Cene",
  "PricingSubtitle": "Jednostavne cene, bez skrivenih troškova. Svi planovi uključuju neograničen broj termina.",
  "PricingMonthly": "mesečno",
  "PricingPopular": "Najpopularnije",
  "PricingSolo": "Solo",
  "PricingSoloSubtitle": "Za pojedince",
  "PricingSoloDesc": "Bez sveske, bez propuštenih poziva — samo rad",
  "PricingSalon": "Salon",
  "PricingSalonSubtitle": "Najbolji izbor za salone sa 2+ radnika",
  "PricingSalonDesc": "U proseku +20–30% više termina uz manje otkazivanja",
  "PricingLanac": "Lanac",
  "PricingLanacSubtitle": "Za više lokacija i ozbiljan rast",
  "PricingLanacDesc": "Cena po dogovoru — prilagođena vašem biznisu",
  "PricingCustom": "Po dogovoru",
  "PricingTrust": "Bez ugovora · Otkaži kad želiš",
  "PricingTryFree": "Počni da primaš online rezervacije",
  "PricingStartSalon": "Povećaj broj zakazivanja",
  "PricingContact": "Automatizuj ceo biznis",
  "PricingFeatureBooking247": "Klijenti zakazuju sami, 24/7",
  "PricingFeatureUnlimitedServices": "Neograničeno usluga i termina",
  "PricingFeatureReminders": "Podsetnici smanjuju otkazivanja",
  "PricingFeatureCustomers": "Upravljanje klijentima",
  "PricingFeaturePush": "Push obaveštenja",
  "PricingFeatureTrial": "14 dana besplatno",
  "PricingFeatureUnlimitedWorkers": "Neograničen broj radnika",
  "PricingFeatureStats": "Pregled zarade po radniku — ko donosi najviše",
  "PricingFeatureWorkerSelection": "Klijenti biraju omiljenog radnika",
  "PricingFeatureCouponsPromo": "Kuponi i promocije pune prazne termine",
  "PricingFeatureSurveys": "Ankete za povratne informacije",
  "PricingFeatureTurnover": "Praćenje prometa i zarade",
  "PricingFeatureOwnBrand": "Sopstveni logo — tvoj brend",
  "PricingFeatureAllSalon": "Sve iz Salon plana",
  "PricingFeatureSms": "SMS podsetnici za klijente (uskoro)",
  "PricingFeatureExport": "Izvoz podataka i napredna analitika",
  "PricingFeatureApi": "API za povezivanje sa sistemima",
  "PricingFeatureLocations": "Više lokacija pod jednim nalogom",
  "PricingFeaturePriority": "Prioritetna podrška — odgovor za 2h",
  "WhatAreYouLookingFor": "Usluga?",
  "Where": "Grad?",
  "SearchAction": "Pretraži",
  "MyLocation": "Moja lokacija",
  "LocationUnavailable": "Lokacija nije dostupna. Izaberite grad ručno.",
  "NoNearbyTown": "Nema dostupnog grada u vašoj blizini. Izaberite grad ručno.",
  "TopRatedSalons": "Najbolje ocenjeni saloni",
  "SlideOf": "Slika {{n}} od {{total}}",
  "ChooseService": "Izaberite uslugu",
  "FooterServices": "Usluge",
  "FooterCities": "Saloni po gradovima",
  "FooterGeneral": "Opšte informacije",
  "TopRatedInCity": "Najbolje ocenjeni {{place}}",
  "ShowAllSalonsInCity": "Prikaži sve salone {{place}} ({{count}})",
  "AllSalonsInCity": "Svi saloni {{place}}",
  "CookieBannerTitle": "Kolačići i privatnost",
  "CookieBannerText": "Koristimo kolačiće da bismo merili posete i prikazivali relevantne oglase. Neophodno funkcionisanje sajta ne zavisi od toga.",
  "CookieBannerPolicy": "Politika privatnosti",
  "CookieAccept": "Prihvatam",
  "CookieDecline": "Samo neophodno"
}
